import { NgModule } from '@angular/core';
import { MapComponent } from './map.component';
import { ListingMarkerComponent } from './markers/listing-marker/listing-marker.component';
import { PlainMarkerComponent } from './markers/plain-marker/plain-marker.component';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { CommonModule } from '@angular/common';
import { NguiMapModule } from '@ngui/map';

@NgModule({
  imports: [
    CommonModule,
    SharedPipesModule,
    NguiMapModule
  ],
  declarations: [
    ListingMarkerComponent,
    PlainMarkerComponent,
    MapComponent
  ],
  exports: [
    ListingMarkerComponent,
    PlainMarkerComponent,
    MapComponent
  ]
})
export class MapModule { }
